import { useEffect, useState } from "react";
import { DEFAULT_MARKETPLACE_RANGE, formatPercent } from "../../../../constants/automapMarketplaceAnalyticsConstants";
import { fetchSupplyAnalytics } from "../../../../services/automapMarketplaceAnalyticsApi";
import { AnalyticsBreakdownTable, AnalyticsSummaryGrid } from "../AdminAnalyticsShared";
import { MarketplaceAnalyticsShell } from "./AdminMarketplaceAnalyticsShared";

export default function AdminSupplyAnalyticsPage() {
  const [range, setRange] = useState(DEFAULT_MARKETPLACE_RANGE);
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    setError("");
    fetchSupplyAnalytics(range)
      .then(setPayload)
      .catch((err) => setError(err.message || "Error al cargar analytics."))
      .finally(() => setLoading(false));
  }, [range]);

  const totals = payload?.totals;

  return (
    <MarketplaceAnalyticsShell
      active="supply"
      title="Analytics de oferta"
      description="Listings, dealers, distribución y frescura de inventario."
      range={range}
      onRangeChange={setRange}
      viewEvent="supply_analytics_viewed"
    >
      {loading ? <p className="dealer-state-box">Cargando…</p> : null}
      {error ? <p className="dealer-state-box">{error}</p> : null}
      {!loading && !error && totals ? (
        <>
          <AnalyticsSummaryGrid
            items={[
              { label: "Activos", value: totals.activeListings },
              { label: "Nuevos (periodo)", value: totals.newListings },
              { label: "Archivados/vendidos", value: totals.archivedSold },
              { label: "Dealers activos", value: totals.activeDealers },
              { label: "Verificados", value: totals.verifiedDealers },
              { label: "En trial", value: totals.trialDealers },
              { label: "Stale", value: totals.staleListings },
              { label: "Sin fotos", value: totals.missingPhotos },
              { label: "Baja calidad", value: totals.lowQuality },
              { label: "Frescura", value: formatPercent(totals.inventoryFreshnessPercent) },
            ]}
          />
          <div className="admin-analytics-grid">
            <AnalyticsBreakdownTable title="Por ciudad" rows={payload.byCity} keyLabel="Ciudad" />
            <AnalyticsBreakdownTable title="Por marca" rows={payload.byMake} keyLabel="Marca" />
            <AnalyticsBreakdownTable title="Por modelo" rows={payload.byModel} keyLabel="Modelo" />
            <AnalyticsBreakdownTable title="Por carrocería" rows={payload.byBodyType} keyLabel="Tipo" />
            <AnalyticsBreakdownTable title="Por rango de precio" rows={payload.byPriceBand} keyLabel="Banda" />
            <AnalyticsBreakdownTable title="Por año" rows={payload.byYear} keyLabel="Año" />
          </div>
        </>
      ) : null}
    </MarketplaceAnalyticsShell>
  );
}
